import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import * as actions from 'modules/files'
import {Field, FieldArray, reduxForm} from 'redux-form';
import Modal from 'react-bootstrap/lib/Modal';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import {FormattedMessage} from 'react-intl';

const adaptFileEventToValue = delegate =>
  e => delegate(e.target.files[0])

const FileInput = ({
  input: {
    value: omitValue,
    onChange,
    onBlur,
    ...inputProps,
  },
  meta: omitMeta,
  ...props,
}) =>
  <input
    onChange={adaptFileEventToValue(onChange)}
    onBlur={adaptFileEventToValue(onBlur)}
    type="file"
    {...inputProps}
    {...props}
  />

class UploadFileDialog extends Dialog {
    constructor(props){
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onSubmit =  this.onSubmit.bind(this);
    }

    onCancel(){
        this.hide();
    }

    onSubmit(file){
        let {onOk} = this.props;
        onOk(file);
        this.hide();
    }

    saveChanges(form){
       let {dispatch} = this.props;
       this.hide();
    }

    render(){
        let {children, widget, handleSubmit, pristine} = this.props;

        return (
            <Modal backdrop="static" enforceFocus={true} show={this.state.show} onHide={this.onCancel}>
                <form onSubmit={handleSubmit(this.onSubmit)}>        
                <Modal.Header closeButton>
                    <Modal.Title><FormattedMessage id="uploadFileDialog.title" /></Modal.Title>
                </Modal.Header>

              
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                        File size should not be grater than 250KB.<br /><br />
                        <Field name="file" component={FileInput}  />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                            <div className="form-group">
                                    <button className="btn btn-success pull-right" type="submit" title="Click Upload"   disabled={pristine}><i className="fa fa-floppy-o"></i>&nbsp; <FormattedMessage id="uploadFileDialog.title" /></button>
                                    <button className="btn btn-default pull-left" type="button" title="Close" onClick={this.hide}><FormattedMessage id="uploadFileDialog.close" /></button>
                            </div>
                        </Col>
                    </Row>  
                </Modal.Body>                              
                </form>

            </Modal>            
        );
    }  
}

UploadFileDialog.propTypes = {
    onOk: PropTypes.func.isRequired
}

export default reduxForm({form: "UploadFile"})(UploadFileDialog);


// WEBPACK FOOTER //
// app/components/UploadFileDialog.jsx